<template>
	<div>
		<div v-if="isSuperAdmin">
			<admin-dashboard />
		</div>
		<div v-else>
			<user-dashboard />
		</div>
	</div>
</template>
<script>
import Organization from "@/modules/organization/organization-layout"

import { mapGetters } from "vuex"
import AdminDashboard from "./dashboard/dashboard-components/admin-dashboard.vue"
import UserDashboard from "./dashboard/dashboard-components/user-dashboard.vue"
export default {
	name: "home",
	components: {
		organization: Organization,
		AdminDashboard,
		UserDashboard
	},
	computed: {
		...mapGetters({
			user: "user/user",
			isSuperAdmin: "user/isSuperAdmin"
		})
	}
}
</script>
